import { SubmissionError } from 'redux-form';

/** Allowed password specials: @ . , _ ! # $ % * */
export const PASSWORD_POLICY_REGEX =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@.,_!#$%*])[A-Za-z\d@.,_!#$%*]{8,}$/;

export const PASSWORD_REQUIREMENTS_MESSAGE =
  'Minimum eight characters, at least one letter, one number and one special character (@ . , _ ! # $ % *)';

export const validateSaveEditPassword = values => {
  if (!values.versionName) {
    throw new SubmissionError({
      versionName: 'Required',
      _error: 'Name the version',
    });
  }
};

export const validateForgottenPassword = values => {
  if (!values.Email) {
    throw new SubmissionError({
      Email: 'Required',
      _error: 'Invalid email address',
    });
  }
  if (values.Email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,21}$/i.test(values.Email)) {
    throw new SubmissionError({
      Email: 'Invalid email address',
      _error: 'Invalid email address',
    });
  }
};

export const validateAddUser = values => {
  if (!values.Email) {
    throw new SubmissionError({
      Email: 'Required',
      _error: 'Invalid email address',
    });
  }
  if (values.Email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,21}$/i.test(values.Email)) {
    throw new SubmissionError({
      Email: 'Invalid email address',
      _error: 'Invalid email address',
    });
  }
};

export const validateLogin = values => {
  if (!values.Email) {
    throw new SubmissionError({
      Email: 'Required',
      _error: 'Invalid email address',
    });
  }
  if (!values.Password) {
    throw new SubmissionError({
      Password: 'Required',
      _error: 'Invalid password',
    });
  }

  if (values.Email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,21}$/i.test(values.Email)) {
    throw new SubmissionError({
      Email: 'Invalid email address',
      _error: 'Invalid email address',
    });
  }

  if (values.Password && !PASSWORD_POLICY_REGEX.test(values.Password)) {
    throw new SubmissionError({
      Password: PASSWORD_REQUIREMENTS_MESSAGE,
      _error: 'Invalid password',
    });
  }
};

export const validateRegistrationNew = values => {
  const errors = {}
  if (!values.firstName) {
    errors.firstName = 'Required'
  }
  if (!values.lastName) {
    errors.lastName = 'Required'
  }
  if (!values.email) {
    errors.email = 'Required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,21}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }
  return errors
};

export const validateRegistration = values => {
  
  if (!values.firstname) {
    throw new SubmissionError({
      Firstname: 'Required',
      _error: 'Invalid firstname',
    });
  }
  if (!values.lastname) {
    throw new SubmissionError({
      Lastname: 'Required',
      _error: 'Invalid lastname',
    });
  }
  if (!values.email) {
    throw new SubmissionError({
      Email: 'Required',
      _error: 'Invalid email address',
    });
  }
  if (!values.Password) {
    throw new SubmissionError({
      Password: 'Required',
      _error: 'Invalid password',
    });
  }
  if (!values.Phone) {
    throw new SubmissionError({
      Phone: 'Required',
      _error: 'Invalid phone',
    });
  }
  if (!values.Code) {
    throw new SubmissionError({
      Code: 'Required',
      _error: 'Invalid code',
    });
  }

  if (values.ConfirmPassword !== values.Password) {
    throw new SubmissionError({
      ConfirmPassword: 'Password mismatched',
      _error: 'Password mismatched',
    });
  }

  if (values.Email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,21}$/i.test(values.Email)) {
    throw new SubmissionError({
      Email: 'Invalid email address',
      _error: 'Invalid email address',
    });
  }
  if (values.Code && !/.{9}/.test(values.Code)) {
    throw new SubmissionError({
      Code: 'At least 9 characters',
      _error: 'Invalid Code',
    });
  }
  if (values.Password && !PASSWORD_POLICY_REGEX.test(values.Password)) {
    throw new SubmissionError({
      Password: PASSWORD_REQUIREMENTS_MESSAGE,
      _error: 'Invalid password',
    });
  }
};

export const validateApproval= values => {
  
  if (!values.managername) {
    
    throw new SubmissionError({
      managername: 'Required',
      _error: 'Invalid firstname',
    });
  }
  if (!values.managernumber) {
    throw new SubmissionError({
      managernumber: 'Required',
      _error: 'Invalid Number',
    });
  }
  if (!values.manageremail) {
    throw new SubmissionError({
      manageremail: 'Required',
      _error: 'Invalid email address',
    });
  }
  if (!values.managerid) {
    throw new SubmissionError({
      managerid: 'Required',
      _error: 'Invalid ID',
    });
  }
};

export const validateAddProjectCode = values => {
  if (!values.Code) {
    throw new SubmissionError({
      Code: 'Required',
      _error: 'Invalid code',
    });
  }
  if (!values.CodeConfirm) {
    throw new SubmissionError({
      CodeConfirm: 'Required',
      _error: 'Invalid code',
    });
  }

  if (values.Code && !/.{9}/.test(values.Code)) {
    throw new SubmissionError({
      Code: 'At least 9 characters',
      _error: 'Invalid Code',
    });
  }

  if (values.CodeConfirm !== values.Code) {
    throw new SubmissionError({
      CodeConfirm: 'Code mismatched',
      _error: 'Code mismatched',
    });
  }
};
